class SearchBar {
    constructor($state) {
        this.$state = $state;
    }

    search() {
        if (this.searchParam) {
            this.$state.go('viewSearch', {
                'searchParam': this.searchParam
            });
        }
    }
}

SearchBar.$inject = ['$state'];

export default SearchBar;

